import { processRefreshTokenResponse, refreshTokenGrantRequest, } from 'oauth4webapi';
import { assertIsNotOAuth2Error } from './assertIsNotOAuth2Error';
import { buildClientConfig } from './buildClientConfig';
export const exchangeRefreshToken = async ({ clientCredentials, authorizationServer, refreshToken, }) => {
    const client = buildClientConfig(clientCredentials);
    const clientAuth = (_, clientAuthClient, __, headers) => {
        const credentials = `${clientAuthClient.client_id}:${clientAuthClient.client_secret}`;
        const encoded = btoa(credentials);
        headers.set('Authorization', `Basic ${encoded}`);
    };
    const response = await refreshTokenGrantRequest(authorizationServer, client, clientAuth, refreshToken);
    const data = await processRefreshTokenResponse(authorizationServer, client, response);
    assertIsNotOAuth2Error(data);
    return data;
};
